@use '../../styling/colors.scss' as *;
@use '../../styling/form-controls.scss' as *;

.LabeledCheckbox {
  @extend %form-control-font;

  display: inline-grid;
  grid-template-columns: auto 1fr;
  gap: 6px;

  &:hover,
  &:focus {

    &.isCheckedHover {
      cursor: pointer;

      *:hover {
        cursor: pointer; // all children in LabeledCheckbox
      }

      span>span {
        border-color: transparent;
        background: $theme-color-checkbox-checked-hover-background;
        box-shadow: 0 0 0 3px $theme-color-checkbox-hover-shadow;
      }
    }

    &.isNotCheckedHover {
      span>span {
        border-color: $theme-color-checkbox-hover-border;
        box-shadow: 0 0 0 3px $theme-color-checkbox-hover-shadow;
      }

      cursor: pointer;

      *:hover {
        cursor: pointer; // all children in LabeledCheckbox
      }
    }
  }

  .checkWrapper {
    display: block;
    position: relative;
    height: 16px;
    width: 16px;
  }

  color: $color-grey-A; // disabled text

  [type='checkbox'] {
    // Basically hide the default checkbox
    appearance: none;
    position: absolute;
    width: 16px;
    height: 16px;
    margin: 0;
    top: 0;
    left: 0;
  }
}